import IdentityPageLayout from "@/features/identity/components/IdentityPageLayout.tsx";
import SignUpForm from '@/features/identity/components/SignUpForm';

const SignUpPage = () => {
    return (
        <IdentityPageLayout>
            <SignUpForm />
        </IdentityPageLayout>
    );
};

export default SignUpPage;
